<template>
  <div v-if="mountedLoad" class="is-relative is-height-100p">
    <div class="pa-20 is-height-100p-60px is-overflow-y-active">
      <societe-selector></societe-selector>
      <!-- Titre de la page -->
      <p class="is-size-6 has-text-grid-1 has-text-weight-bold pb-20">
        {{ !isEditView
          ? $t('creerPanneau.titlePage')
          : $t('modifierPanneau.titlePage', {referencePanneau: panneau.referencePanneau}) }}
      </p>
      <MsgError
        v-if="isError"
        class="msgError"
        type="is-danger"
        :msgs="msgErrors"
        :key="`MsgError-${keyComponent}`"
        @close="initializeErrorObj"/>
      <!-- Info géneral du panneau -->
      <InfoPanneau
        @msg-error="showMsgError([$event])"
        :error="error"
        :click="isClick"
        :panneau="panneau"
        :isLoadingRegie="load.regie"
        :regies="list.regie"
        :surface-occupee="surfaceOccupee"
        @saisie-surface="surfaceSaisie = true"
        :key="`InfoPanneau-${keyComponent}`"/>
      <!-- Propoition financière lié au panneau-->
      <PropositionFinanciere
        @msg-error="showMsgError([$event])"
        :error="error"
        :click="isClick"
        :panneau="panneau"
        :regies="list.regie"
        :key="`PropositionFinanciere-${keyComponent}`"/>
      <!-- Commentaire sur le panneau -->
      <div class="mt-40">
        <p class="has-text-grid-1 is-size-14px has-text-weight-bold pb-20">
          {{$t('creerPanneau.titleCommentaire')}}
        </p>
        <b-field
          :label="$t('creerPanneau.labelChamp.commentaire')"
          custom-class="has-text-default is-size-7">
          <b-input
            v-model="panneau.commentaire"
            :rows="4"
            :disabled="disabled"
            type="textarea">
          </b-input>
        </b-field>
      </div>
    </div>
    <!-- Footer de la page -->
    <div class="is-footer-child-content has-background-white">
      <div>
        <div class="level mx-20 mb-10 mt-10">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="level-item" v-if="isEditView">
            <b-button
              @click="archiverOuDesarchiver(panneau.actif)"
              :type="!panneau.actif ? 'is-success' : 'is-danger'">
              <p class="is-size-14px has-text-weight-bold">
                {{ !panneau.actif
                  ? $t("modifierPanneau.btnDesarchiver")
                  : $t("modifierPanneau.btnArchiver") }}
              </p>
            </b-button>
          </div>
          <div class="level-item">
            <b-button type="is-white" @click="actionToReturn">
              <p class="is-size-14px has-text-default">
                {{$t('general.btnAnnuler')}}
              </p>
            </b-button>
          </div>
          <div class="level-item">
            <b-button type="is-primary" @click="creerPanneau" :disabled="disabled">
              <p class="is-size-14px has-text-weight-bold">
                {{ !isEditView
                  ? $t('creerPanneau.btnValider')
                  : $t('modifierPanneau.btnValider') }}
              </p>
            </b-button>
          </div>
        </div>
      </div>
      </div>
    </div>
    <modal-confirm
      :modal-is-active="modalIsActive"
      :message="$t('listePanneau.modalConfirmation.message')"
      :info-message="$t('listePanneau.modalConfirmation.infoMessage')"
      :libelle-btn-valide="$t('listePanneau.modalConfirmation.libelleBtnValide')"
      @modalIsClose="modalIsActive = $event"
      @isValide="archiverOuDesarchiver()"
      type="is-confirmation"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import ModalConfirm from "@/components/general/modal.vue";
import MsgError from '@/components/general/messageErreur';
import SocieteSelector from '@/components/general/societeSelector';
import InfoPanneau from '@/components/recommandation/creerPanneau/infoPanneau.vue';
import PropositionFinanciere from '@/components/recommandation/creerPanneau/propositionFinanciere.vue';
import gestionErreur from '@/services/general/gestionErreur';
import genererGuid from '@/services/general/genererGuid';
import genererPanneau, { genererBudgetGeneration } from '@/services/gestionPanneau/genererPanneau';
import { panneauToMarker} from '@/services/recommandation/recommandations';
import { getIconPanneau } from '@/services/gestionIcon/iconColorGetter';
import { isValidPanneau, getMsgErrorPanneau, genererObjectError, genererObjectErrorBudgets } from '@/services/gestionPanneau/validationPanneau';
import { SET_MARKER_PANNEAU, DELETE_RESTOR_PANNEAU } from '@/store/modules/recommandations-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import { browseClients } from '@/api/clients/index';
import * as clientConf from '@/configuration/clientConf';
import { calculerDateFinPremiereEcheance, calculerDateFinBudgetaire } from '@/services/ligneCommande/calculDataLigne';
import debounce from 'lodash/debounce';
import formatIsoDate from '@/services/general/formatIsoDate';
import { getSurfaceOccupee, getSurfaceProposee, SURFACE_MAX } from '@/services/gestionPanneau/surfacePanneau';
import { SET_PANNEAU_EXISTANT } from '@/store/modules/recommandations-mutation-type';

const Recommandations = createNamespacedHelpers('recommandations');
const Societe = createNamespacedHelpers('societe');

export default {
  components: {
    MsgError,
    InfoPanneau,
    SocieteSelector,
    ModalConfirm,
    PropositionFinanciere,
  },
  data () {
    return {
      isClick: 0,
      msgErrors: [],
      isError: false,
      mountedLoad: false,
      modalIsActive: false,
      panneau: genererPanneau(),
      error: genererObjectError(),
      list: { regie: [] },
      load: { regie: false },
      keyComponent: genererGuid(),
      surfaceOccupee: 0,
      surfaceOccupeeRequeteId: 0,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Recommandations.mapGetters({
      panneaux: 'panneaux',
      pointDeVenteRecommandation: 'pointDeVente',
      recommandation: 'recommandation',
      panneauExistant: 'panneauExistant',
    }),
    isEditView() {
      return !!this.$route.params.guid;
    },
    disabled() {
      return this.$route.name === 'view-panneau';
    },
    periodesBudgets() {
      return (this.panneau.budgets || [])
        .map(budget => `${formatIsoDate(budget.dateDebut)}|${formatIsoDate(budget.dateFin)}`)
        .join(';');
    },
  },
  watch: {
    periodesBudgets() {
      this.loadSurfaceOccupeeDebounce();
    },
  },
  created() {
    this.loadSurfaceOccupeeDebounce = debounce(this.loadSurfaceOccupee, 500);
  },
  beforeDestroy() {
    this.loadSurfaceOccupeeDebounce.cancel();
  },
  methods: {
    ...Recommandations.mapMutations({
      setMarkeurPanneau: SET_MARKER_PANNEAU,
      actionDeleteOrRestorPanneau: DELETE_RESTOR_PANNEAU,
      setPanneauExistant: SET_PANNEAU_EXISTANT,
    }),
    ...Recommandations.mapActions({
      setPanneau: 'setPanneauToDevis',
    }),
    initializeErrorObj() {
      this.isError = false;
      this.error = genererObjectError();
      this.error.budgets = genererObjectErrorBudgets(this.panneau.budgets);
    },
    showMsgError(msgs) {
      this.msgErrors = msgs;
      this.isError = true;
    },
    initDefaultPanneau() {
      const item = genererPanneau();
      const { dateDebut, dateFin } = item.budgetGeneration;
      item.budgetGeneration.dateFin = calculerDateFinBudgetaire(dateDebut, dateFin, this.pointDeVenteRecommandation);
      item.budgetGeneration.dateFinPremiereEcheance = calculerDateFinPremiereEcheance(dateDebut, item.budgetGeneration.dateFin, this.pointDeVenteRecommandation);
      item.icon = getIconPanneau(item);
      return item;
    },
    async creerPanneau() {
      if (!isValidPanneau(this.panneau, this.error)) {
        const messages = getMsgErrorPanneau(this.error).map(key => this.$t(key));
        this.showMsgError(messages);
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadSurfaceOccupee();
        if (this.surfaceOccupee + this.panneau.pourcentageSurface > SURFACE_MAX) {
          this.$buefy.toast.open({
            message: this.$t('creerPanneau.messageWarningSurface', { surfaceOccupee: this.surfaceOccupee }),
            type: 'is-warning',
          });
        }
        await this.setPanneau(this.panneau);
        this.panneau = this.initDefaultPanneau();
        this.isClick += 1;
        this.actionToReturn();
      } catch (error) {
        gestionErreur(this.$t('errors.erreurCreationPanneau'), error);
      } finally {
        loadingComponent.close();
      }
    },
    actionToReturn() {
      this.$router.push({ name: 'liste-panneau' });
    },
    archiverOuDesarchiver(openModal = false) {
      if (openModal) {
        this.modalIsActive = true;
        return;
      }
      this.actionDeleteOrRestorPanneau(this.panneau);
      this.modalIsActive = false;
      this.$router.back();
    },
    async loadSurfaceOccupee() {
      const requeteId = ++this.surfaceOccupeeRequeteId;
      // Panneau sous contrat : sa propre commande occupe la face, on ne la compte pas contre lui-même
      if (this.panneau.estPanneauSousContrat) {
        this.surfaceOccupee = 0;
        return;
      }
      try {
        const recommandationId = this.recommandation ? this.recommandation.id : null;
        const surfaceOccupee = await getSurfaceOccupee(this.panneau.id, this.panneau.budgets || [], recommandationId);
        if (requeteId === this.surfaceOccupeeRequeteId) this.surfaceOccupee = surfaceOccupee;
      } catch (error) {
        gestionErreur(this.$t('errors.erreurRecuperationSurfaceOccupee'), error);
      }
    },
    async proposerSurfacePanneauExistant() {
      try {
        const recommandationId = this.recommandation ? this.recommandation.id : null;
        const surfaceOccupee = await getSurfaceOccupee(this.panneau.id, [this.panneau.budgetGeneration], recommandationId);
        this.panneau.pourcentageSurface = getSurfaceProposee(surfaceOccupee);
      } catch (error) {
        gestionErreur(this.$t('errors.erreurRecuperationSurfaceOccupee'), error);
      }
    },
    async getListeRegies() {
      this.load.regie = true;
      try {
        const query = {
          type: clientConf.TYPE_FOURNISSEUR,
          sousType: clientConf.SOUS_TYPE_CONFRERE,
          societeId: this.societeActiveId,
          archive: null
        };
        const res = (await browseClients(clientConf.WITHOUT_LOGO, query)).data;
        this.list.regie = res;
      } finally {
        this.load.regie = false;
      }
    },
  },
  async mounted() {
    if (!this.pointDeVenteRecommandation) {
      gestionErreur(this.$t('creerPanneau.msgErrorNoPointDeVente'));
    }
    const loadingComponent = this.$buefy.loading.open();
    try {
      let panneauData = this.initDefaultPanneau();
      if (this.$route.params.guid) {
        const find = this.panneaux.find((el) => el.guid === this.$route.params.guid);
        if (find) {
          panneauData = cloneDeep(find);
          panneauData.icon = getIconPanneau(panneauData);
        }
        if (!panneauData.budgetGeneration) panneauData.budgetGeneration = genererBudgetGeneration();
        if (!panneauData.budgets) panneauData.budgets = [];
      } else if (this.panneauExistant) {
        panneauData = { ...this.panneauExistant, budgetGeneration: panneauData.budgetGeneration };
        this.setPanneauExistant(null);
      }
      this.panneau = panneauData;
      if (!this.isEditView && this.panneau.id) await this.proposerSurfacePanneauExistant();
      if (!this.disabled) this.setMarkeurPanneau(panneauToMarker(this.panneau));
      this.initializeErrorObj();
      this.mountedLoad = true;
      await this.getListeRegies();
    } catch (error) {
      gestionErreur('Erreur interne', error);
    } finally {
      loadingComponent.close();
    }
  },
};
</script>


